
// src/constants.js
export const ORG_ID = "Verdonk-Broccoli";
export const ACTIVE_YEAR = String(new Date().getFullYear());
export const MACHINES = ["1","2","3","4"];
export const OTHER_MACHINE_ID = "other";
export const OTHER_MACHINE_QR = `machine-${OTHER_MACHINE_ID}`;
export const KIST_QR =  /^(kist|houtenkist)-\d{4}$/;
export const MACHINE_QR = /^machine-(\d)$/;
export const ROLES = {
  ADMIN: "admin",
  INSCANNER: "inscanner",
  INSCANNER_PLUS : "inscanner_plus",
  UITSCANNER: "uitscanner",
  SUPERVISOR: "supervisor",
  PLANNING: "planning",
  
};
export const CENTRAL_ROLES = Object.freeze({
  KISTEN_SUPERVISOR: "kisten.supervisor",
  KISTEN_PLANNING: "kisten.planning",
  KISTEN_ADMIN: "kisten.admin",
});
export const SNIJ_GROEPEN   = ["A", "B", "C", "Robot"];
export const GEWICHT_OPTIES = [">250", ">400", ">450", ">500"];
export const SOORTEN        = ["Koros", "Ironman", "Spinnaker","Titanium","Malibu","Pharlap","Spello","Firstlap"];
export const AFLEVER_CEL_ID = "aflevercel";
export const COR_CEL_ID = "cor";
export const KOELCEL_OPTIES = ["6", "5", "4"];
export const KOELCEL_OPTIES_ALL = ["6", "5", "4", AFLEVER_CEL_ID, COR_CEL_ID];
export const KOELTIJD_SECONDEN = 15 * 60 * 60;
export const CAPACITEIT_PER_RIJ = 28;
export const WAGEN_GROOTTE = 14;
export const KG_PER_KIST = 280;
export const KG_PER_HOUTENKIST = 400;
export const TEN_DAYS_MS = 10 * 24 * 60 * 60 * 1000;
export const MACHINE_LOW_STOCK_THRESHOLD = 8;
export const RIJ_NOTITIE_MAX_WORDS = 40;
export const RIJ_NOTITIE_MAX_LENGTH = 240;

